
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.067 4H14a5 5 0 015 5v3a5 5 0 01-5 5h-1.166v-2H14a3 3 0 003-3V9a3 3 0 00-3-3H5.067v4L0 5l5.067-5v4z"}}),_c('text',{attrs:{"font-family":"HelveticaNeue-Bold, Helvetica Neue","font-size":"10","font-weight":"bold","letter-spacing":".125"}},[_c('tspan',{attrs:{"x":"0","y":"19"}},[_v('15')])])])
          )
        }
      }
    